// DocumentList.js
import React, { useState } from 'react';
import DocumentCard from './DocumentCard';
 
const DocumentList = ({ documents, searchTerms }) => {
    const [openedCards, setOpenedCards] = useState([]); // Track opened cards by docket_number
 
    const handleCardClick = (docketNumber) => {
        if (openedCards.includes(docketNumber)) {
            setOpenedCards(openedCards.filter((card) => card !== docketNumber)); // Collapse the card if it's already open
        } else {
            setOpenedCards([...openedCards, docketNumber]); // Open the card
        }
    };
 
    return (
        <div className="document-list">
            {documents.map((doc, index) => (
                <DocumentCard
                    key={index}
                    document={doc}
                    isOpen={openedCards.includes(doc.docket_number)}
                    onCardClick={handleCardClick}
                    searchTerms={searchTerms}
                />
            ))}
        </div>
    );
};
 
export default DocumentList;